import { BetOptions } from '@components/index'

const BetSettings = () => {
    return (
        <div className={'relative flex flex-col justify-center items-center w-full touch-auto [&_div]:touch-auto'}>
            <BetOptions shouldCloseOnBetChosen={false} />
        </div>
    )
}

export default BetSettings
